import { combineAndDedupArrays, updateObject } from 'shared/utility';
import * as actionTypes from 'store/actions/actionTypes';

/* eslint-disable no-plusplus */

const initialState = {
  currentLogs: {
    LogIds: null,
    Posts: [],
    loading: false,
    PostCount: 0,
    Page: {},
    Categories: [],
    Users: [],
    PostCountReturned: 0,
    PageSize: null,
  },
  Tags: {
    WhatTags: [],
    WhoTags: [],
    LocationTags: [],
    loaded: false,
  },
  LogsDetails: [],
  MembersByLog: [],
  Drafts: {
    Drafts: [],
    loading: false,
    TotalDraftsCount: 0,
    Page: {},
  },
  multiViewCategories: {},
  multiViewPeople: {},
  logInvitees: [],
  showGiftsDraftsModal: false,
  currentPost: null,
  loading: false,
  error: null,
  submitted: false,
  inviteSubmitted: false,
};

const fetchPostSuccess = (state, action) => {
  const updatedCurrentLogsPosts = [...state.currentLogs.Posts];
  const updatedFetchedPostIndex = updatedCurrentLogsPosts.findIndex((post) => post.Post.PostId === action.Post.Post.PostId);
  if (updatedFetchedPostIndex !== -1) {
    const updatedFetchedPost = { ...updatedCurrentLogsPosts[updatedFetchedPostIndex] };
    updatedFetchedPost.MyHistory = { viewed: true };
    updatedCurrentLogsPosts[updatedFetchedPostIndex] = updatedFetchedPost;
    return updateObject(state, {
      currentLogs: {
        ...state.currentLogs,
        Posts: updatedCurrentLogsPosts,
      },
    });
  }
  return state;
};

const fetchLogStart = (state, action) => {
  let updatedState = updateObject(state, {
    loading: true,
  });
  const isSameLog = state.currentLogs.LogIds && action.LogIds && state.currentLogs.LogIds === action.LogIds;
  if (action.Page === 1) {
    updatedState = updateObject(state, {
      currentLogs: {
        ...state.currentLogs,
        LogIds: isSameLog ? state.currentLogs.LogIds : null,
        Posts: [],
        Page: {},
        Users: [],
        Categories: [],
        PostCountReturned: 0,
        PageSize: null,
      },
      loading: true,
    });
  }
  return updatedState;
};

const fetchLogSuccess = (state, action) => {
  let updatedPosts = state.currentLogs.Posts.length > 0 && action.Page.PageNum !== 1 ? state.currentLogs.Posts.map((post) => post) : [];
  const returnedPosts = action.Posts ? action.Posts : [];
  updatedPosts = combineAndDedupArrays(updatedPosts, returnedPosts);
  return updateObject(state, {
    currentLogs: {
      ...state.currentLog,
      LogIds: action.LogIds,
      Posts: updatedPosts && updatedPosts.length >= 0 ? updatedPosts : [],
      PostCount: action.PostCount,
      Page: action.Page,
      Categories: action.Categories,
      Users: action.Users,
      PageSize: action.PageSize,
      PostCountReturned: action.Posts ? action.Posts.length : 0,
    },
    loading: false,
  });
};

const fetchLogFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
    currentLogs: {
      ...state.currentLogs,
    },
    loading: false,
  });
};

const fetchMultiViewColumnsStart = (state, action) => {
  const columnsObjectName = action.ColumnType === 'categories' ? 'multiViewCategories' : 'multiViewPeople';
  const updatedMultiViewColumns = { ...state[columnsObjectName] };
  for (let i = 0; i < action.ColumnNames.length; i++) {
    const columnName = action.ColumnNames[i];
    updatedMultiViewColumns[columnName] = updateObject(updatedMultiViewColumns[columnName], {
      Posts:
        state[columnsObjectName][columnName] && state[columnsObjectName][columnName].Posts && action.PageNum > 1
          ? state[columnsObjectName][columnName].Posts
          : [],
      loading: true,
      error: null,
    });
  }
  return updateObject(state, {
    [columnsObjectName]: updatedMultiViewColumns,
  });
};

const fetchMultiViewColumnsSuccess = (state, action) => {
  const columnsObjectName = action.ColumnType === 'categories' ? 'multiViewCategories' : 'multiViewPeople';
  const updatedMultiViewColumns = { ...state[columnsObjectName] };
  for (let i = 0; i < action.ColumnNames.length; i++) {
    const columnName = action.ColumnNames[i];
    const returnedPosts = action.ColumnReturnObjects[columnName].Posts ? action.ColumnReturnObjects[columnName].Posts : [];
    updatedMultiViewColumns[columnName] = updateObject(updatedMultiViewColumns[columnName], {
      Posts: combineAndDedupArrays(updatedMultiViewColumns[columnName].Posts, returnedPosts),
      morePostsAvailable: returnedPosts.length === action.PageSize,
      loading: false,
      PageNum: action.PageNum,
    });
  }
  return updateObject(state, {
    [columnsObjectName]: updatedMultiViewColumns,
  });
};

const fetchMultiViewColumnsFailed = (state, action) => {
  const columnsObjectName = action.ColumnType === 'categories' ? 'multiViewCategories' : 'multiViewPeople';
  const updatedMultiViewColumns = { ...state[columnsObjectName] };
  for (let i = 0; i < action.ColumnNames.length; i++) {
    const columnName = action.ColumnNames[i];
    const failedCategory = updateObject(updatedMultiViewColumns[columnName], {
      error: action.error,
    });
    updatedMultiViewColumns[columnName] = failedCategory;
  }
  return updateObject(state, {
    [columnsObjectName]: updatedMultiViewColumns,
  });
};

const removeMultiViewColumns = (state, action) => {
  const columnsObjectName = action.ColumnType === 'categories' ? 'multiViewCategories' : 'multiViewPeople';
  const updatedMultiViewColumns = { ...state[columnsObjectName] };
  for (let i = 0; i < action.ColumnNames.length; i++) {
    if (updatedMultiViewColumns[action.ColumnNames[i]]) delete updatedMultiViewColumns[action.ColumnNames[i]];
  }
  return updateObject(state, {
    [columnsObjectName]: updatedMultiViewColumns,
  });
};

const clearAllLogs = (state) => {
  // need to update multiViewCategories to render no posts for each columnName
  return updateObject(state, {
    currentLogs: {
      LogIds: null,
      Posts: [],
      loading: false,
      PostCount: 0,
      Page: {},
      Categories: [],
      Users: [],
      PostCountReturned: 0,
      PageSize: null,
    },
  });
};

const fetchDraftsStart = (state, action) => {
  let updatedState = updateObject(state, {
    loading: true,
  });
  if (action.Page === 1) {
    updatedState = updateObject(state, {
      Drafts: {
        ...state.Drafts,
        Drafts: [],
        Page: {},
      },
      loading: true,
    });
  }
  return updatedState;
};

const fetchDraftsSuccess = (state, action) => {
  let updatedDrafts = state.Drafts.Drafts.length > 0 && action.Page.PageNum !== 1 ? state.Drafts.Drafts.map((draft) => draft) : [];
  const returnedDrafts = action.Drafts ? action.Drafts : [];
  updatedDrafts = combineAndDedupArrays(updatedDrafts, returnedDrafts);
  return updateObject(state, {
    Drafts: {
      ...state.Drafts,
      Drafts: updatedDrafts,
      TotalDraftsCount: action.TotalDraftsCount,
      Page: action.Page,
    },
    loading: false,
  });
};

const fetchDraftsFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
    Drafts: {
      ...state.Drafts,
    },
    loading: false,
  });
};

const fetchLogsDetailsStart = (state) => {
  return updateObject(state, {
    error: null,
    LogsDetails: initialState.LogsDetails,
    loading: true,
  });
};

const fetchLogsDetailsFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const fetchLogsDetailsSuccess = (state, action) => {
  return updateObject(state, {
    LogsDetails: action.logsDetails,
    loading: false,
    error: null,
  });
};

const fetchMembersForLogsStart = (state) => {
  return updateObject(state, {
    MembersByLog: [],
    error: null,
  });
};

const fetchMembersForLogsSuccess = (state, action) => {
  return updateObject(state, {
    MembersByLog: action.logs,
  });
};

const fetchMembersForLogsFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
  });
};

const fetchTagsStart = (state) => {
  return updateObject(state, {
    error: null,
    loaded: false,
  });
};

const fetchTagsSuccess = (state, action) => {
  let WhatTags = [];
  let LocationTags = [];
  let WhoTags = [];
  action.logs.forEach((log) => {
    WhatTags = combineAndDedupArrays(WhatTags, log.Tags.WhatTags);
    WhoTags = combineAndDedupArrays(WhoTags, log.Tags.WhoTags);
    LocationTags = combineAndDedupArrays(LocationTags, log.Tags.LocationTags);
  });
  return updateObject(state, {
    Tags: {
      WhatTags,
      WhoTags,
      LocationTags,
      loaded: true,
    },
  });
};

const fetchTagsFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
  });
};

const createLogStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: null,
    submitted: false,
  });
};

const createLogSuccess = (state) => {
  return updateObject(state, {
    loading: false,
    submitted: true,
  });
};

const createLogFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
    submitted: false,
  });
};

// const logUpdateStart = (state) => {
//   return updateObject(state, {
//     loading: true,
//     submitted: false,
//   });
// };
//
// const logUpdateSuccess = (state) => {
//   return updateObject(state, {
//     loading: false,
//     submitted: true,
//   });
// };
//
// const logUpdateFailed = (state, action) => {
//   return updateObject(state, {
//     loading: false,
//     error: action.error,
//     submitted: false,
//   });
// };

const logAddRemoveMembersStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: null,
    inviteSubmitted: false,
  });
};

const logAddRemoveMembersSuccess = (state) => {
  return updateObject(state, {
    loading: false,
    inviteSubmitted: true,
    logInvitees: [],
  });
};

const logAddRemoveMembersFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
    inviteSubmitted: false,
  });
};

const logRemoveArchivedUsersStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: null,
  });
};

const logRemoveArchivedUsersSuccess = (state) => {
  return updateObject(state, {
    loading: false,
  });
};

const logRemoveArchivedUsersFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
  });
};

const logInviteNewUsersStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: null,
    inviteSubmitted: false,
  });
};

const logInviteNewUsersSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    inviteSubmitted: true,
    logInvitees: [...state.logInvitees, action.invitee],
  });
};

const logInviteNewUsersFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
    inviteSubmitted: false,
  });
};

const logLeaveStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: null,
  });
};

const logLeaveSuccess = (state) => {
  return updateObject(state, {
    loading: false,
  });
};

const logLeaveFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
  });
};

const logUpdateUserAccessStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: null,
  });
};

const logUpdateUserAccessSuccess = (state) => {
  return updateObject(state, {
    loading: false,
  });
};

const logUpdateUserAccessFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
  });
};

const logTransferHostStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: null,
  });
};

const logTransferHostSuccess = (state) => {
  return updateObject(state, {
    loading: false,
  });
};

const logTransferHostFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
  });
};

const toggleGiftsDraftsModal = (state) => {
  return updateObject(state, {
    showGiftsDraftsModal: !state.showGiftsDraftsModal,
  });
};

const logoutSuccess = (state) => {
  return updateObject(state, {
    currentLogs: {
      LogIds: null,
      Posts: [],
      loading: false,
      PostCount: 0,
      Page: {},
      Categories: [],
      Users: [],
      PostCountReturned: 0,
      PageSize: null,
    },
    Tags: {
      WhatTags: [],
      WhoTags: [],
      LocationTags: [],
      loaded: false,
    },
    LogsDetails: [],
    Drafts: {
      Drafts: [],
      loading: false,
      TotalDraftsCount: 0,
      Page: {},
    },
    logInvitees: [],
    multiViewCategories: {},
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LOG_SUCCESS:
      return fetchLogSuccess(state, action);
    case actionTypes.FETCH_LOG_FAILED:
      return fetchLogFailed(state, action);
    case actionTypes.FETCH_LOG_START:
      return fetchLogStart(state, action);
    case actionTypes.FETCH_POST_SUCCESS:
      return fetchPostSuccess(state, action);
    case actionTypes.FETCH_MULTI_VIEW_COLUMNS_START:
      return fetchMultiViewColumnsStart(state, action);
    case actionTypes.FETCH_MULTI_VIEW_COLUMNS_SUCCESS:
      return fetchMultiViewColumnsSuccess(state, action);
    case actionTypes.FETCH_MULTI_VIEW_COLUMNS_FAILED:
      return fetchMultiViewColumnsFailed(state, action);
    case actionTypes.REMOVE_MULTI_VIEW_COLUMNS:
      return removeMultiViewColumns(state, action);

    case actionTypes.CLEAR_ALL_LOGS:
      return clearAllLogs(state, action);
    case actionTypes.FETCH_DRAFTS_START:
      return fetchDraftsStart(state, action);
    case actionTypes.FETCH_DRAFTS_SUCCESS:
      return fetchDraftsSuccess(state, action);
    case actionTypes.FETCH_DRAFTS_FAILED:
      return fetchDraftsFailed(state, action);
    case actionTypes.FETCH_LOGS_DETAILS_START:
      return fetchLogsDetailsStart(state, action);
    case actionTypes.FETCH_LOGS_DETAILS_SUCCESS:
      return fetchLogsDetailsSuccess(state, action);
    case actionTypes.FETCH_LOGS_DETAILS_FAILED:
      return fetchLogsDetailsFailed(state, action);
    case actionTypes.FETCH_MEMBERS_FOR_LOGS_START:
      return fetchMembersForLogsStart(state, action);
    case actionTypes.FETCH_MEMBERS_FOR_LOGS_SUCCESS:
      return fetchMembersForLogsSuccess(state, action);
    case actionTypes.FETCH_MEMBERS_FOR_LOGS_FAILED:
      return fetchMembersForLogsFailed(state, action);
    case actionTypes.FETCH_TAGS_SUCCESS:
      return fetchTagsSuccess(state, action);
    case actionTypes.FETCH_TAGS_START:
      return fetchTagsStart(state, action);
    case actionTypes.FETCH_TAGS_FAILED:
      return fetchTagsFailed(state, action);
    case actionTypes.CREATE_LOG_START:
      return createLogStart(state, action);
    case actionTypes.CREATE_LOG_SUCCESS:
      return createLogSuccess(state, action);
    case actionTypes.CREATE_LOG_FAILED:
      return createLogFailed(state, action);
    case actionTypes.LOG_UPDATE_START:
      return createLogSuccess(state, action);
    case actionTypes.LOG_UPDATE_SUCCESS:
      return createLogSuccess(state, action);
    case actionTypes.LOG_UPDATE_FAILED:
      return createLogSuccess(state, action);
    // case actionTypes.CREATE_LOG_FAILED:
    case actionTypes.LOG_ADD_REMOVE_MEMBERS_START:
      return logAddRemoveMembersStart(state, action);
    case actionTypes.LOG_ADD_REMOVE_MEMBERS_SUCCESS:
      return logAddRemoveMembersSuccess(state, action);
    case actionTypes.LOG_ADD_REMOVE_MEMBERS_FAILED:
      return logAddRemoveMembersFailed(state, action);
    case actionTypes.LOG_REMOVE_ARCHIVED_USERS_START:
      return logRemoveArchivedUsersStart(state, action);
    case actionTypes.LOG_REMOVE_ARCHIVED_USERS_SUCCESS:
      return logRemoveArchivedUsersSuccess(state, action);
    case actionTypes.LOG_REMOVE_ARCHIVED_USERS_FAILED:
      return logRemoveArchivedUsersFailed(state, action);
    case actionTypes.LOG_INVITE_NEW_USERS_START:
      return logInviteNewUsersStart(state, action);
    case actionTypes.LOG_INVITE_NEW_USERS_SUCCESS:
      return logInviteNewUsersSuccess(state, action);
    case actionTypes.LOG_INVITE_NEW_USERS_FAILED:
      return logInviteNewUsersFailed(state, action);
    case actionTypes.LOG_LEAVE_START:
      return logLeaveStart(state, action);
    case actionTypes.LOG_LEAVE_SUCCESS:
      return logLeaveSuccess(state, action);
    case actionTypes.LOG_LEAVE_FAILED:
      return logLeaveFailed(state, action);
    case actionTypes.LOG_UPDATE_USER_ACCESS_START:
      return logUpdateUserAccessStart(state, action);
    case actionTypes.LOG_UPDATE_USER_ACCESS_SUCCESS:
      return logUpdateUserAccessSuccess(state, action);
    case actionTypes.LOG_UPDATE_USER_ACCESS_FAILED:
      return logUpdateUserAccessFailed(state, action);
    case actionTypes.LOG_TRANSFER_HOST_START:
      return logTransferHostStart(state, action);
    case actionTypes.LOG_TRANSFER_HOST_SUCCESS:
      return logTransferHostSuccess(state, action);
    case actionTypes.LOG_TRANSFER_HOST_FAILED:
      return logTransferHostFailed(state, action);
    case actionTypes.TOGGLE_GIFTS_DRAFTS_MODAL:
      return toggleGiftsDraftsModal(state, action);
    case actionTypes.LOGOUT_SUCCESS:
      return logoutSuccess(state, action);
    default:
      return state;
  }
};
export default reducer;
